import React from 'react';
import {BoxTitle} from "../../../components/admin/BoxTitle";
import {RaceForm} from "../../../components/admin/race/RaceForm";
import {useParams} from "react-router-dom";

export const Add = () => {
  const uuid: undefined | string = useParams().uuid;

  return (
    <>
      <BoxTitle title="Ajouter une sortie"/>
      <RaceForm seasonId={uuid} />
    </>
  )
}
